<div class="profile-card-header">
    <h2>{{ 'employees.jobAndPay.taxCredits.header' | translate }}</h2>
</div>
<div>{{ 'employees.jobAndPay.taxCredits.description' | translate }}</div>
<ui-banner [variant]="'bulb'">
    <div [innerHTML]="'employees.jobAndPay.taxCredits.help' | translate"></div>
</ui-banner>
<app-tax-credit-table [employee]="employee" [jurisdiction]="'federal'" (onDataLoad)="handleDataLoad($event)" />
<app-tax-credit-table [employee]="employee" [jurisdiction]="'provincial'" (onDataLoad)="handleDataLoad($event)" />
